import { WmsService } from '../resource'

const  WmsStorageModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    SET_DATA (state, data) {
      state.data = data
    }
  },
  actions: {
    createData ({ commit, state }, data) {
        return WmsService.StorageCreate(data)
    },
    updateData ({ commit, state }, data) {
        return WmsService.StorageUpdate(data.id,data.payload)
    },
    deleteData ({ commit, state }, id) {
        return WmsService.StorageDelete(id)
    },
    async listData ({ commit, state }) {
      try{
        const data = await WmsService.StorageList()
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch(err)
      {
        console.log(err)
        commit('SET_DATA', [])
      }
    }
  },
  getters: {
    getData (state) {
      return state.data
    },
	getDataWithAll(state) {
		return  [
			{ID:0,Name:"--- คลังสินค้า --- "},...state.data ];
	},
  }
}

export default WmsStorageModule
